import {useEffect, useRef, useState} from 'react';
import strapiDao from '../../../../../dao/strapiDao';
import {useTranslation} from 'react-i18next';
import langCode from '../../../../../utils/langCode';
import webUtils from '../../../../../utils/webUtils';
import demostoreUtils from '../../../../../utils/demostoreUtils';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import _isObject from 'lodash/isObject';

export default function useStrapi(type, opts = {}) {
  const {defaultEnu = false, inputStrapiResponse} = opts;
  const getPageKey = path =>
    _get(path.match(/\/business\/showcase(?:\/content)?\/([^/]+)/), '[1]') ||
    '';
  const pageKey =
    ['BUSINESS_DEMO_STORE', 'BUSINESS_DEMO_STORE_PAGE'].includes(type) &&
    getPageKey(window.location.pathname);
  const shouldSkipQuery = !!inputStrapiResponse;
  const params = new URLSearchParams(window.location.search);
  const cmsId = params.get('cmsId');
  const {i18n} = useTranslation();
  const languageType = langCode.convertLanguageCode(i18n.language || 'en');
  const [strapiResponse, _setStrapiResponse] = useState(
    shouldSkipQuery
      ? inputStrapiResponse
      : {
          loaded: false,
          content: {},
          showStrapi: false,
          showI18n: !type,
          showBlank: !!type,
        }
  );

  const [pfFormId, setPfFormId] = useState('');
  const formIdRef = useRef(pfFormId);
  useEffect(() => {
    const handler = event => {
      if (demostoreUtils.isDemostore() && !webUtils.isMsrFormPreview()) return;
      if (!_get(event, 'data') || _isObject(event.data)) return;

      const formId = event.data;
      console.log('[event] strapi formId:', formId, event);

      if (formIdRef.current !== formId) {
        formIdRef.current = formId;
        setPfFormId(formId);
        window.removeEventListener('message', handler);
      }
    };

    window.addEventListener('message', handler);
    return () => {
      window.removeEventListener('message', handler);
    };
  }, []);

  const setStrapiResponse = response => {
    _setStrapiResponse(prev => ({...prev, ...response}));
  };

  const handleResponse = response => {
    const content = _isEmpty(response) ? {} : response.attributes;
    const showStrapi = !_isEmpty(content);
    const showI18n = !type || _isEmpty(content);
    const showBlank = !showStrapi && !showI18n;
    setStrapiResponse({
      loaded: true,
      content,
      showStrapi,
      showI18n,
      showBlank,
    });
  };

  useEffect(() => {
    if (shouldSkipQuery) {
      return;
    }

    _setStrapiResponse({
      content: {},
      showStrapi: false,
      showI18n: !type,
      showBlank: !!type,
    });
    if (!type) {
      return;
    }
    if (cmsId) {
      strapiDao
        .getProductPageById({
          type: type,
          id: cmsId,
        })
        .then(res => {
          handleResponse(res);
        })
        .catch(err => {
          handleResponse({});
        });
      return;
    }
    const params = {
      type,
      languageType,
      defaultEnu,
      pageKey: pageKey || undefined,
    };
    if (webUtils.isMakeupArUrl() && (!languageType || languageType === 'enu')) {
      params.languageType = 'end';
      params.defaultEnu = true;
    }
    strapiDao
      .getProductPageByLanguage(params, pfFormId)
      .then(res => {
        handleResponse(res);
      })
      .catch(err => {
        handleResponse({});
      });
  }, [
    cmsId,
    languageType,
    type,
    defaultEnu,
    pfFormId,
    pageKey,
    shouldSkipQuery,
  ]);

  return {
    strapiResponse: shouldSkipQuery ? inputStrapiResponse : strapiResponse,
  };
}
